<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
      @change_language="handleHeaderClick"
    ></HeaderComponent>
    <div class="container mt-5">
      <h1 class="text-center mb-4">{{ pageContent.page_title }}</h1>
      <p class="text-center">{{ pageContent.effective_date }}</p>
      <p class="text-center">{{ pageContent.last_updated }}</p>
      <br>
      <div class="card shadow-sm p-4">
        <p>{{ pageContent.intro_p1 }}</p>
        <br>
        <p>{{ pageContent.intro_p2 }}</p>

        <h4>{{ pageContent.section_1_title }}</h4>
        <p>{{ pageContent.section_1_p1 }}</p>
        <ul>
          <li>{{ pageContent.section_1_list_1 }}</li>
          <li>{{ pageContent.section_1_list_2 }}</li>
          <li>{{ pageContent.section_1_list_3 }}</li>
          <li>{{ pageContent.section_1_list_4 }}</li>
        </ul>

        <h4>{{ pageContent.section_2_title }}</h4>
        <p>{{ pageContent.section_2_p1 }}</p>
        <ul>
          <li>{{ pageContent.section_2_list_1 }}</li>
          <li>{{ pageContent.section_2_list_2 }}</li>
          <li>{{ pageContent.section_2_list_3 }}</li>
          <li>{{ pageContent.section_2_list_4 }}</li>
          <li>{{ pageContent.section_2_list_5 }}</li>
        </ul>

        <h4>{{ pageContent.section_3_title }}</h4>
        <p>{{ pageContent.section_3_p1 }}</p>
        <ul>
          <li>{{ pageContent.section_3_list_1 }}</li>
          <li>{{ pageContent.section_3_list_2 }}</li>
          <li>{{ pageContent.section_3_list_3 }}</li>
          <li>{{ pageContent.section_3_list_4 }}</li>
        </ul>

        <h4>{{ pageContent.section_4_title }}</h4>
        <p>{{ pageContent.section_4_p1 }}</p>

        <h4>{{ pageContent.section_5_title }}</h4>
        <p>{{ pageContent.section_5_p1 }}</p>
        <ul>
          <li>{{ pageContent.section_5_list_1 }}</li>
          <li>{{ pageContent.section_5_list_2 }}</li>
          <li>{{ pageContent.section_5_list_3 }}</li>
        </ul>

        <h4>{{ pageContent.section_6_title }}</h4>
        <p>{{ pageContent.section_6_p1 }}</p>

        <h4>{{ pageContent.section_7_title }}</h4>
        <p>{{ pageContent.section_7_p1 }}</p>

        <h4>{{ pageContent.section_8_title }}</h4>
        <p>{{ pageContent.section_8_p1 }}</p>

        <h4>{{ pageContent.section_9_title }}</h4>
        <p>{{ pageContent.section_9_p1 }}</p>
        <p class="fw-bold">{{ pageContent.contact_email }}</p>
      </div>
    </div>
    <br><br>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "Relocation",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      showModal: false,
      videoUrl: "",
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.privacy_policy[lang];
      
      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];


      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        };

        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        };
        
      }  
    },
  },
};
</script>

<style>
ul li {
  list-style: inherit;
}
</style>